"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportClient = void 0;
const BaseClient_1 = require("../BaseClient");
class ImportClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async requestImport(request) {
        const response = await this.axiosInstance.request({
            url: '/api/v1/import/post',
            method: 'POST',
            headers: {
                'Content-Type': request.contentType,
            },
            params: {
                entity: request.entity,
                metadata: JSON.stringify(request.metadata),
                relationIds: request.relationIds,
            },
            data: request.content,
        });
        return response.data;
    }
    async createImportRelation(request) {
        const response = await this.axiosInstance.request({
            url: '/api/v1/import/relations/post',
            method: 'POST',
            headers: {
                'Content-Type': request.contentType,
            },
            params: {
                entity: request.entity,
                name: request.name,
            },
            data: request.content,
        });
        return response.data;
    }
    async getImportDetails(request) {
        const response = await this.axiosInstance.request({
            url: '/api/v1/import/get',
            method: 'GET',
            params: {
                id: request.id,
            },
        });
        return response.data;
    }
}
exports.ImportClient = ImportClient;
